import React from "react";
import HeaderComponent from "components/card/HeaderComponent";
import AwardeeCard from "./AwardeeCard";
import { Award, Trophy } from "lucide-react";
import { useNavigate } from "react-router-dom";



const HyvidAwardWinner = () => {
  const navigate = useNavigate();

  return (
    <HeaderComponent
      title="Hyvid Awards Winners"
      description="Team members recognized for exceptional contributions"
      cardBorder="white-purple"
      icon={<Award className="w-6 h-6 text-white"/>}
      colorTheme="gradient emerald !rounded-full"
      descriptionClass="text-sm text-slate-700"
      rightNav={
        <button 
          onClick={() => navigate("/console/hyvid-awards")}
          className="inline-flex items-center justify-center rounded-xl text-sm font-medium transition-all border h-9 px-4 py-2 border-purple-300 text-purple-700 hover:bg-purple-50">
          <p>View All Awards</p>
        </button>
      }
    >
      <div >
        <AwardeeCard/>
        <div className="mt-6 p-4 rounded-lg bg-gradient-to-r from-emerald-50 to-purple-50 dark:from-emerald-950/30 dark:to-purple-950/30 border border-purple-200 dark:border-purple-900/50">
          <div className="flex items-center gap-3">
              <Trophy className="w-5 h-5 text-purple-600 flex-shrink-0"/>
                <span className="text-[13px] text-slate-700 flex gap-1">
                  <p className="font-semibold">
                    Want to nominate a colleague?
                  </p> 
                  <p>
                    Visit the Rewards & Recognition section to submit nominations for these prestigious awards.
                  </p>
                </span>
            </div>
          </div>
      </div>
   </HeaderComponent>
  );
};

export default HyvidAwardWinner;
